import React, { useEffect, useState } from 'react';
import Banner from './Banner';
import Activities from './Activities/Activities';
import Hotels from './Hotels';
import Packages from './Packages';
import { CounterSection, Footer, Testimonials } from './Footer';

const MobileHome = ({
  searchLocation,
  selectedLocationType,
  onLocationSelect,
  onLocationTypeSelect
}) => {
  const [showPackages, setShowPackages] = useState(true);

  useEffect(() => {
    const handleToggle = () => setShowPackages(!showPackages);
    window.addEventListener('toggleMobileView', handleToggle);
    return () => window.removeEventListener('toggleMobileView', handleToggle);
  }, [showPackages]);

  return (
    <div>
      {showPackages ? (
        <Packages />
      ) : (
        <>
          <Banner onLocationSelect={onLocationSelect} onLocationTypeSelect={onLocationTypeSelect} />
          <Activities selectedLocation={searchLocation} />
          <Hotels searchLocation={searchLocation} selectedLocationType={selectedLocationType} />
          <CounterSection />
          <Testimonials />
          <Footer />
        </>
      )}
    </div>
  );
};

export default MobileHome;